import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Table, Button, Spinner, Badge } from 'react-bootstrap';
import { FiPlus, FiEye, FiEdit2, FiTrash2 } from '../../utils/icons';
import api from '../../services/api';
import { notify } from '../../stores/useNotificationStore';

interface Contrato {
  id: number;
  razao_social: string;
  nome_fantasia: string;
  cnpj: string;
  tipo_agente: string;
  vigencia_fim: string;
  clausulas_privacidade: boolean;
  adequado_lgpd: boolean;
}

const ContractListPage: React.FC = () => {
  const [contratos, setContratos] = useState<Contrato[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    const res = await api.getContratos();
    if (res.success && res.data) setContratos(res.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm('Deseja excluir este contrato?')) return;
    const res = await api.deleteContrato(id);
    if (res.success) load();
    else notify.error('Erro ao excluir.');
  };

  return (
    <Container fluid className="p-4">
      <Row className="mb-3 align-items-center">
        <Col><h1 className="h3 mb-0">Fornecedores</h1></Col>
        <Col xs="auto">
          <Button variant="primary" onClick={() => navigate('/app/contratos')}>
            <FiPlus /> Novo Fornecedor
          </Button>
        </Col>
      </Row>
      {loading ? (
        <div className="text-center py-5"><Spinner animation="border" /></div>
      ) : (
        <Table responsive hover bordered>
          <thead className="table-light">
            <tr>
              <th>Razão Social</th>
              <th>CNPJ</th>
              <th>Tipo Agente</th>
              <th>Vigência Fim</th>
              <th>LGPD</th>
              <th>Adequado LGPD</th>
              <th className="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            {contratos.length === 0 ? (
              <tr><td colSpan={7} className="text-center text-muted py-4">Nenhum contrato cadastrado.</td></tr>
            ) : contratos.map(c => (
              <tr key={c.id}>
                <td>{c.razao_social}<br /><small className="text-muted">{c.nome_fantasia}</small></td>
                <td>{c.cnpj}</td>
                <td>{c.tipo_agente || '—'}</td>
                <td>{c.vigencia_fim ? new Date(c.vigencia_fim).toLocaleDateString('pt-BR') : '—'}</td>
                <td>
                  <Badge bg={c.clausulas_privacidade ? 'success' : 'secondary'}>
                    {c.clausulas_privacidade ? 'Sim' : 'Não'}
                  </Badge>
                </td>
                <td>
                  <Badge bg={c.adequado_lgpd ? 'success' : 'secondary'}>
                    {c.adequado_lgpd ? 'Sim' : 'Não'}
                  </Badge>
                </td>
                <td className="text-center">
                  <Button size="sm" variant="outline-secondary" className="me-1" onClick={() => navigate(`/app/contratos/visualizar/${c.id}`)}><FiEye /> Ver</Button>
                  <Button size="sm" variant="outline-primary" className="me-1" onClick={() => navigate(`/app/contratos/editar/${c.id}`)}><FiEdit2 /> Editar</Button>
                  <Button size="sm" variant="outline-danger" onClick={() => handleDelete(c.id)}><FiTrash2 /> Excluir</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default ContractListPage;
